var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { WorkflowService } from '../../../../services/workload/workflow.service';
var StaffAssignedRequestsComponent = /** @class */ (function () {
    function StaffAssignedRequestsComponent(workflowService) {
        this.workflowService = workflowService;
        this.staffId = 0;
        this.viewModel = {
            table: {
                headerText: {
                    requestId: 'Request Id',
                    customer: 'Customer Name',
                    status: 'Status',
                    dueDate: 'Due Date',
                    centreName: 'Centre Name',
                    standardId: 'Standard Id'
                },
                requests: []
            }
        };
    }
    StaffAssignedRequestsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.workflowService.getAssignedRequests(this.staffId).toPromise().then(function (result) {
            _this.viewModel.table.requests = result;
        });
    };
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StaffAssignedRequestsComponent.prototype, "staffId", void 0);
    StaffAssignedRequestsComponent = __decorate([
        Component({
            selector: 'staff-assigned-requests',
            template: require('./staff-assigned-requests.component.html'),
            styles: [require('./staff-assigned-requests.component.scss')]
        }),
        __metadata("design:paramtypes", [WorkflowService])
    ], StaffAssignedRequestsComponent);
    return StaffAssignedRequestsComponent;
}());
export { StaffAssignedRequestsComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhZmYtYXNzaWduZWQtcmVxdWVzdHMuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3RhZmYtYXNzaWduZWQtcmVxdWVzdHMuY29tcG9uZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQXFCLEtBQUssRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUVwRSxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFPakY7SUFNSSx3Q0FBb0MsZUFBZ0M7UUFBaEMsb0JBQWUsR0FBZixlQUFlLENBQWlCO1FBSnBELFlBQU8sR0FBVyxDQUFDLENBQUM7UUFLaEMsSUFBSSxDQUFDLFNBQVMsR0FBRztZQUNiLEtBQUssRUFBRTtnQkFDSCxVQUFVLEVBQUU7b0JBQ1IsU0FBUyxFQUFFLFlBQVk7b0JBQ3ZCLFFBQVEsRUFBRSxlQUFlO29CQUN6QixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsT0FBTyxFQUFFLFVBQVU7b0JBQ25CLFVBQVUsRUFBRSxhQUFhO29CQUN6QixVQUFVLEVBQUUsYUFBYTtpQkFDNUI7Z0JBQ0QsUUFBUSxFQUFFLEVBQUU7YUFDZjtTQUNKLENBQUM7SUFDTixDQUFDO0lBRU0saURBQVEsR0FBZjtRQUFBLGlCQUlDO1FBSEcsSUFBSSxDQUFDLGVBQWUsQ0FBQyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDLFVBQUEsTUFBTTtZQUMxRSxLQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxRQUFRLEdBQUcsTUFBTSxDQUFDO1FBQzNDLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQXhCUTtRQUFSLEtBQUssRUFBRTs7bUVBQTRCO0lBRjNCLDhCQUE4QjtRQUwxQyxTQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUseUJBQXlCO1lBQ25DLFFBQVEsRUFBRSxPQUFPLENBQUMsMENBQTBDLENBQUM7WUFDN0QsTUFBTSxFQUFFLENBQUMsT0FBTyxDQUFDLDBDQUEwQyxDQUFDLENBQUM7U0FDaEUsQ0FBQzt5Q0FPdUQsZUFBZTtPQU4zRCw4QkFBOEIsQ0EyQjFDO0lBQUQscUNBQUM7Q0FBQSxBQTNCRCxJQTJCQztTQTNCWSw4QkFBOEIifQ==